<template>
  <div class="container">
    <h5>{{accountName}}</h5>
    <form>
      <label for="report-for-month">
        Mês e Ano
        <input @change="redrawCharts" v-model="selectedPeriod" type="month"
          name="report-for-month" id="report-for-month"
          required />
      </label>
    </form>
    <p class="label">Montantes da conta para o período selecionado</p>
    <ul class="account-totals">
      <li class="account-total">
        <span class="total-name">entradas</span>
        <span class="total-value ti">{{ incomeTotal }} {{ accountCurrency }}</span>
      </li>
      <li class="account-total">
        <span class="total-name">saídas</span>
        <span class="total-value te">{{ expensesTotal }} {{ accountCurrency }}</span>
      </li>
      <li class="account-total">
        <span class="total-name">disponível</span>
        <span class="total-value ta">{{ accountBalance.toFixed(2) }} {{ accountCurrency }}</span>
      </li>
    </ul>
    <p class="label">Visão geral da conta</p>
    <div class="account-report">
      <span class="account-report-title">Entradas e Saídas -
        {{formatTheDate(`${selectedPeriod}-01`)}}</span>
      <canvas class="chart income-and-expenses-chart">

      </canvas>
    </div>
    <div class="account-report">
      <span class="account-report-title">Entradas - {{formatTheDate(`${selectedPeriod}-01`)}}</span>
      <canvas class="chart income-chart">

      </canvas>
    </div>
    <div class="account-report">
      <span class="account-report-title">Saídas - {{formatTheDate(`${selectedPeriod}-01`)}}</span>
      <canvas class="chart expenses-chart">

      </canvas>
    </div>
    <AppButton @click.native="goToOperationRegister" class="add-operation"
      text="Adicionar Operação" />
    <p p @click="goToRoute" id="/contas" class="cancel-button" role="button">Voltar ao início</p>
    <TheBottomNav :linksList="linksList" @click.native="changeRoute"/>
  </div>
</template>

<script>
import axios from "axios";
import { Chart, registerables, registerabregisterables } from "chart.js";
import AppButton from "@/components/AppButton.vue";
import TheBottomNav from "@/components/TheBottomNavbar.vue";
import { parseUserId, requestBuilder } from "../misc/util";

export default {
  name: "TheHistory",
  components: {
    AppButton,
    TheBottomNav
  },
  created() {
    this.getCurrentMonthAndYear();
    this.registerChartElements();
  },
  beforeMount() {
    if (this.accountData) this.setAccountData();
  },
  mounted() {
    this.createIncomeAndExpenseChart();
    this.createIncomeChart();
    this.createExpenseChart();
  },
  data() {
    return {
      selectedPeriod: null,
      accountOwnerID: null,
      accountData: {},
      accountID: null,
      accountName: null,
      accountBalance: null,
      accountCurrency: null,
      incomeAndExpenseChart: null,
      incomeAndExpenseContext: null,
      expenseAndIncomeChartType: "bar",
      expenseAndIncomeChartOptions: {
        responsive: true,
        plugins: {
          legend: {
            labels: {
              boxWidth: 10
            }
          },
          title: {
            display: false
          }
        },
        scales: {
          y: {
            grid: {
              display: true
            }
          },
          x: {
            grid: {
              display: false,
            }
          }
        }
      },
      incomeContext: null,
      incomeChart: null,
      incomeChartType: "doughnut",
      pieChartOptions: {
        responsive: true,
        plugins: {
          legend: {
            labels: {
              boxWidth: 10
            }
          },
          title: {
            display: false
          }
        }
      },
      expenseContext: null,
      expenseChart: null,
      expenseChartType: "doughnut",
      backgroundColorsForCharts: [
        "rgba(255, 99, 132, 0.6)",
        "rgba(54, 162, 235, 0.6)",
        "rgba(255, 206, 86, 0.6)",
        "rgba(75, 192, 192, 0.6)",
        "rgba(153, 102, 255, 0.6)",
        "rgba(255, 159, 64, 0.6)",
        "rgba(75, 192, 192, 0.8)"
      ],
      backgroundColorsForChartsScrambled: [
        "rgba(153, 102, 255, 0.6)",
        "rgba(54, 162, 235, 0.6)",
        "rgba(75, 192, 192, 0.6)",
        "rgba(255, 159, 64, 0.6)",
        "rgba(75, 192, 192, 0.8)",
        "rgba(255, 206, 86, 0.6)",
        "rgba(255, 99, 132, 0.6)"
      ],
      accountOperations: [],
      linksList: []
    };
  },
  computed: {
    arraysIntoElements() {
      const arraysOfOperations = this.operationsToList.map(array => array.operationsWithSigns);
      const operations = [];
      arraysOfOperations.forEach(array => {
        operations.push(...array);
      });
      return operations;
    },
    hasOperations() {
      const accountOperationsListLength = this.accountOperations.length;

      if (accountOperationsListLength > 0) return true;
      return false;
    },
    incomeTotal() {
      if (this.hasOperations) {
        const operations = this.arraysIntoElements;
        const incomes = operations.filter(v => v.operation_type === "income");
        return incomes.map(v => v.amount).reduce((acc, val) => acc + val, 0).toFixed(2);
      }
      return 0;
    },
    expensesTotal() {
      if (this.hasOperations) {
        const operations = this.arraysIntoElements;
        const expenses = operations.filter(v => v.operation_type === "expense");
        return Math.abs(expenses.map(v => v.amount).reduce((acc, val) => acc + val, 0)).toFixed(2);
      }
      return 0;
    },
    operationsToList() {
      const sortedOperations = this.sortArrayOfObjects(this.accountOperations, "effective_by");
      const arrayOfDates = this.newArrayOf(sortedOperations, "effective_by");
      const nonDuplicates = this.removeDuplicates(arrayOfDates);
      const groupedOperations = this.groupOperationsByDate(nonDuplicates, sortedOperations);
      const filteredOperations = groupedOperations.filter(v => {
        const periodYear = new Date(this.selectedPeriod).getFullYear();
        const periodMonth = new Date(this.selectedPeriod).getMonth();

        const date = new Date(v.date);
        const mth = date.getMonth();
        const y = date.getFullYear();

        if (periodMonth === mth) {
          if (periodYear === y) {
            return true;
          }
        }
        return false;
      });
      return filteredOperations;
    },
    labelsForBarChart() {
      return this.operationsToList.map(o => new Date(o.date).getDate());
    },
    labelsForIncomePieChart() {
      return this.dataForPieChartIncomeDataset.map(go => go.operationType);
    },
    labelsForExpensePieChart() {
      return this.dataForPieChartExpenseDataset.map(go => go.operationType);
    },
    dataForBarChartIncomeDataset() {
      const data = [];
      this.labelsForBarChart.forEach(l => {
        this.operationsToList.forEach(o => {
          const dayOfTheOperation = new Date(o.date).getDate();
          if (dayOfTheOperation === l) {
            const operations = o.operationsWithSigns.map(op => op)
              .filter(op => op.operation_type === "income")
              .map(op => op.amount);

            if (operations.length > 0) {
              const total = operations.reduce((acc, val) => acc + val, 0).toFixed(2);
              data.push(total);
            } else data.push(0);
          }
        });
      });
      return data;
    },
    dataForBarChartExpenseDataset() {
      const data = [];
      this.labelsForBarChart.forEach(l => {
        this.operationsToList.forEach(o => {
          const dayOfTheOperation = new Date(o.date).getDate();
          if (dayOfTheOperation === l) {
            const operations = o.operationsWithSigns.map(op => op)
              .filter(op => op.operation_type === "expense")
              .map(op => op.amount);

            if (operations.length > 0) {
              const total = operations.reduce((acc, val) => acc + val, 0).toFixed(2);
              data.push(total);
            } else data.push(0);
          }
        });
      });
      return data;
    },
    dataForPieChartIncomeDataset() {
      const allOperations = this.arraysIntoElements.filter(el => el.operation_type === "income");
      const operationTypes = this.removeDuplicates(this.arraysIntoElements.filter(o => o.operation_type === "income")
        .map(op => op.operationCategory.name));
      const groupedOperationsByType = operationTypes.map(ot => {
        const operationsOfThisType = allOperations.filter(op => op.operationCategory.name === ot);
        const total = operationsOfThisType.reduce((acc, op) => acc + op.amount, 0);

        return {
          operationType: ot,
          total
        };
      });
      return groupedOperationsByType;
    },
    dataForPieChartExpenseDataset() {
      const allOperations = this.arraysIntoElements.filter(el => el.operation_type === "expense");
      const operationTypes = this.removeDuplicates(this.arraysIntoElements.filter(o => o.operation_type === "expense")
        .map(op => op.operationCategory.name));
      const groupedOperationsByType = operationTypes.map(ot => {
        const operationsOfThisType = allOperations.filter(op => op.operationCategory.name === ot);
        const total = operationsOfThisType.reduce((acc, op) => acc + op.amount, 0);

        return {
          operationType: ot,
          total
        };
      });
      return groupedOperationsByType;
    }
  },
  methods: {
    registerChartElements() {
      Chart.register(...registerables);
      Chart.defaults.font.family = "Open Sans Regular";
    },
    updateIncomeAndExpenseChart() {
      if (this.incomeAndExpenseChart) {
        this.incomeAndExpenseChart.data.labels = this.labelsForBarChart;
        this.incomeAndExpenseChart.data.datasets[0].data = this.dataForBarChartIncomeDataset;
        this.incomeAndExpenseChart.data.datasets[1].data = this.dataForBarChartExpenseDataset;
        this.incomeAndExpenseChart.update();
      } else this.createIncomeAndExpenseChart();
    },
    updateIncomeChart() {
      if (this.incomeChart) {
        this.incomeChart.data.labels = this.labelsForIncomePieChart;
        this.incomeChart.data.datasets[0].data = this.dataForPieChartIncomeDataset
          .map(dfi => dfi.total);
        this.incomeChart.update();
      } else this.createIncomeChart();
    },
    updateExpenseChart() {
      if (this.expenseChart) {
        this.expenseChart.data.labels = this.labelsForExpensePieChart;
        this.expenseChart.data.datasets[0].data = this.dataForPieChartExpenseDataset
          .map(dfe => dfe.total);
        this.expenseChart.update();
      } else this.createExpenseChart();
    },
    redrawCharts() {
      this.updateIncomeAndExpenseChart();
      this.updateIncomeChart();
      this.updateExpenseChart();
    },
    createIncomeAndExpenseChart() {
      const el = document.querySelector(".income-and-expenses-chart");
      if (el) {
        this.incomeAndExpenseContext = el.getContext("2d");
        if (this.incomeAndExpenseContext) {
          if (this.operationsToList.length > 0) {
            const chartData = () => {
              const labels = this.labelsForBarChart;

              const datasets = [
                {
                  label: "Entrada",
                  data: this.dataForBarChartIncomeDataset,
                  backgroundColor: ["#25A0A4"],
                  borderWidth: 0,
                  borderRadius: 8
                },
                {
                  label: "Saida",
                  data: this.dataForBarChartExpenseDataset,
                  backgroundColor: ["#D52941"],
                  borderWidth: 0,
                  borderRadius: 8
                }
              ];

              return {
                labels,
                datasets
              };
            };

            const configuration = (data) => (
              { type: this.expenseAndIncomeChartType,
                data,
                options: this.expenseAndIncomeChartOptions });

            this.incomeAndExpenseChart = new Chart(this.incomeAndExpenseContext,
              configuration(chartData()));
          }
        }
      }
    },
    createIncomeChart() {
      const el = document.querySelector(".income-chart");
      if (el) {
        this.incomeContext = el.getContext("2d");
        if (this.incomeContext) {
          if (this.operationsToList.length > 0) {
            const chartData = () => {
              const labels = this.labelsForIncomePieChart;

              const datasets = [
                {
                  label: "Entradas",
                  data: this.dataForPieChartIncomeDataset.map(go => go.total),
                  backgroundColor: this.backgroundColorsForCharts,
                  hoverOffset: 0
                }
              ];

              return {
                labels,
                datasets
              };
            };

            const configuration = (data) => ({ type: this.incomeChartType,
              data,
              options: this.pieChartOptions });

            this.incomeChart = new Chart(this.incomeContext, configuration(chartData()));
          }
        }
      }
    },
    createExpenseChart() {
      const el = document.querySelector(".expenses-chart");
      if (el) {
        this.expenseContext = el.getContext("2d");
        if (this.expenseContext) {
          if (this.operationsToList.length > 0) {
            const chartData = () => {
              const labels = this.labelsForExpensePieChart;

              const datasets = [
                {
                  label: "Saidas",
                  data: this.dataForPieChartExpenseDataset.map(go => go.total),
                  backgroundColor: this.backgroundColorsForChartsScrambled,
                  hoverOffset: 0
                }
              ];

              return {
                labels,
                datasets
              };
            };

            const configuration = (data) => ({ type: this.expenseChartType,
              data,
              options: this.pieChartOptions });

            this.expenseChart = new Chart(this.expenseContext, configuration(chartData()));
          }
        }
      }
    },
    setAccountData() {
      if (this.$route.params.accountData) {
        this.accountData = this.$route.params.accountData;
        this.accountID = this.$route.params.accountData.id;
        this.accountOwnerID = this.$route.params.accountData.user_id;
        this.accountName = this.$route.params.accountData.account_name;
        this.accountBalance = this.$route.params.accountData.current_balance;
        this.accountCurrency = this.$route.params.accountData.currency.short_name;
        this.accountOperations = this.$route.params.accountData.operations;
        this.linksList = [
          {
            routeName: "accountTransactions",
            name: "Transações",
            icon: "transactions",
            path: `/contas/${this.accountID}/transaccoes`
          },
          {
            routeName: "accountReport",
            name: "Relatório",
            icon: "report",
            path: `/contas/${this.accountID}/relatorios`
          },
          {
            routeName: "accountSettings",
            name: "Dados da conta",
            icon: "settings",
            path: `/contas/${this.accountID}/definicoes`
          }
        ];
      } else this.$router.push({ name: "accounts" });
    },
    getCurrentMonthAndYear() {
      const year = new Date().getFullYear();
      const month = `0${new Date().getMonth() + 1}`;
      if (month.length === 3) {
        const fixedMonth = month.slice(1, 3);
        this.selectedPeriod = `${year}-${fixedMonth}`;
      } else this.selectedPeriod = `${year}-${month}`;
    },
    formatTheDate(date, formatOption) {
      const defaultOption = { year: "numeric", month: "long" };
      if (formatOption === undefined) {
        const formattedDate = new Date(date).toLocaleDateString("pt-PT", defaultOption);
        const firstChar = formattedDate.charAt(0).toUpperCase();
        const slicedFormattedDate = formattedDate.slice(1);
        return `${firstChar}${slicedFormattedDate}`;
      }
      const formattedDate = new Date(date).toLocaleDateString("pt-PT", formatOption);
      const firstChar = formattedDate.charAt(0).toUpperCase();
      const slicedFormattedDate = formattedDate.slice(0, 1);
      return `${firstChar}${slicedFormattedDate}`;
    },
    sortArrayOfObjects(array, attribute) {
      const arrayCopy = [...array];
      return arrayCopy.sort((a, b) => {
        if (a[attribute] < b[attribute]) return 1;
        if (a[attribute] > b[attribute]) return -1;
        return 0;
      });
    },
    newArrayOf(array, attribute) {
      return array.map(v => v[attribute]);
    },
    customIndexOf(array, value) {
      const indexOf = [];
      array.forEach((el, index) => {
        if (el === value) {
          indexOf.push(index);
        }
      });
      const [firstOcurrence] = indexOf;
      return firstOcurrence;
    },
    removeDuplicates(array) {
      return this.sortArrayOfObjects(array).filter(
        (el, index, originalArray) => this.customIndexOf(originalArray, el) === index
      );
    },
    groupOperationsByDate(arrayOfDates, arrayOfOperations) {
      const groupedOperationsByDate = arrayOfDates.map(d => {
        const operationsOnThisDate = arrayOfOperations.filter(v => v.effective_by === d);

        const operationsWithSigns = operationsOnThisDate.map(v => {
          const newAmount = v.operation_type === "expense" ? -Math.abs(v.amount) : v.amount;

          const operation = v;
          operation.amount = newAmount;

          return operation;
        });

        const total = operationsWithSigns.reduce((acc, v) => acc + v.amount, 0);

        return {
          date: d,
          total,
          operationsWithSigns
        };
      });

      return groupedOperationsByDate;
    },
    goToOperationRegister() {
      const currentRoutePath = this.$route.path;
      const nextRoutePath = `/contas/${this.$route.params.accountID}/adicionar-operacao`;

      if (currentRoutePath !== nextRoutePath) {
        this.$router.push({
          name: "accountOperationRegister",
          params: { accountData: this.$route.params.accountData }
        });
      }
    },
    goToRoute(e) {
      const { srcElement: { id: nextRoute } } = e;
      const currentRoute = this.$route.path;

      if (currentRoute !== nextRoute) this.$router.push(nextRoute);
    },
    changeRoute(e) {
      if (e.srcElement.id) {
        const { srcElement: { id } } = e;
        if (this.$route.name !== id) {
          this.$router.push({ name: id,
            params: { accountID: this.accountID,
              accountData: this.$route.params.accountData } });
        }
      }
    }
  }
};
</script>

<style scoped>
h5 {
  margin-bottom: 1.6rem;
}

label,
.label {
  color: var(--color-tertiary);
}

.label {
  font-size: 0.75rem;
}

form {
  margin-bottom: 1.6rem;
}

input {
  width: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  padding-bottom: 4rem;
}

.account-totals {
  display: flex;
  justify-content: space-between;
  margin: 0.8rem 0 1.6rem 0;
}

.account-total {
  background-color: var(--color-white);
  border-radius: 5px;
  padding: 0.4rem 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.15));
}

.total-name {
  color: var(--color-primary);
  font-size: 0.75rem;
}

.total-name,
.total-value {
  text-align: center;
}

.ti {
  color: var(--color-secondary);
}

.te {
  color: var(--color-senary);
}

.ta {
  color: var(--color-tertiary);
}

.account-report {
  background-color: var(--color-white);
  width: 100%;
  padding: 0.8rem;
  margin-bottom: 1.4rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.account-report:last-child {
  margin-bottom: 2.4rem;
}

.account-report-title {
  font-size: 0.85rem;
  color: var(--color-tertiary);
}

.add-operation {
  background-color: var(--color-primary);
  color: var(--color-quaternary);
  margin: 1rem auto 1.6rem auto;
}

.cancel-button {
  color: var(--color-secondary);
  text-align: center;
  margin: 0 auto 2.6rem auto;
  cursor: pointer;
}
</style>
